import { PaletteOptions } from '@material-ui/core/styles/createPalette';

const palette: PaletteOptions = {
  primary: {
    light: '#363c43',
    main: '#22282f',
    dark: '#0e141b',
    contrastText: '#f0f0f0',
  },
  secondary: {
    light: '#66e0ff',
    main: '#00aeef',
    dark: '#007fbc',
    contrastText: '#22282f',
  },
  background: {
    default: '#f0f0f0',
  },
};

export default palette;
